import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Response } from '../models';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private httpClient: HttpClient) { }

  public generateToken(): Observable<Response<string>> {
    const url = `${environment.apiEndpoint}/token/GenerateExternal`;
    return this.httpClient.get(url, {
      withCredentials: true
    });
  }

  public refreshToken(): Observable<Response<string>> {
    const url = `${environment.apiEndpoint}/token/Refresh`;
    return this.httpClient.get(url, {
      withCredentials: true
    });
  }
}
